import { ApplicationId } from "@1games-ru/region-shared/dist/enums/phone/application-id";

export const applicationsInfo = {
  [ApplicationId.Taxi]: {
    name: "Такси",
    icon: "/svg/tablet/my-house.svg",
  },
  [ApplicationId.RentScooter]: {
    name: "Аренда самоката",
    icon: "/svg/tablet/my-house.svg",
  },
  [ApplicationId.CellularCommunication]: {
    name: "Сотовая связь",
    icon: "/svg/tablet/my-house.svg",
  },
};
